export default __webpack_public_path__ + "static/media/Warmonger's Club.90a5c8f2.jpg";